import createSagaMiddleWare from 'redux-saga';
import authSaga from 'spw-redux/modules/auth/sagas';
import userSaga from 'spw-redux/modules/user/sagas';
import homeSaga from 'spw-redux/modules/home/sagas';
import projectsSaga from 'spw-redux/modules/projects/sagas';
import librarySaga from 'spw-redux/modules/library/sagas';
import floorplanSaga from 'spw-redux/modules/floorplan/sagas';
import programSummary from 'spw-redux/modules/program-summary/sagas';
import programmingProgramSummarySaga from 'spw-redux/modules/program-summary/programming/sagas';
import feedbackSaga from 'spw-redux/modules/feedback/sagas';
import ouSaga from 'spw-redux/modules/ou/sagas';
import customSpacesSaga from 'spw-redux/modules/custom_spaces/sagas';
import calculatorsSaga from 'spw-redux/modules/calculators/sagas';
import organizationsSaga from 'spw-redux/modules/organization/sagas';
import messagesSaga from 'spw-redux/modules/UI/messages/sagas';
import settingsSaga from 'spw-redux/modules/settings/sagas';
import spaceTypesSaga from 'spw-redux/modules/space_types/sagas';
import spaceTypeCategoriesSaga from 'spw-redux/modules/project-space-type-categories/sagas';
import worksheetSaga from 'spw-redux/modules/worksheet/sagas';
import downloadSaga from 'spw-redux/modules/downloads/sagas';
import usersSaga from 'spw-redux/modules/users/sagas';
import clientsSaga from 'spw-redux/modules/clients/sagas';
import teamsSaga from 'spw-redux/modules/teams/sagas';
import requestsSaga from 'spw-redux/modules/join-requests/sagas';
import benchmarkReportsSaga from 'spw-redux/modules/benchmark-reports/sagas';

export const sagaMiddleware = createSagaMiddleWare();

export const run = () => {
  sagaMiddleware.run(messagesSaga);
  sagaMiddleware.run(authSaga);
  sagaMiddleware.run(userSaga);
  sagaMiddleware.run(homeSaga);
  sagaMiddleware.run(projectsSaga);
  sagaMiddleware.run(librarySaga);
  sagaMiddleware.run(floorplanSaga);
  sagaMiddleware.run(programSummary);
  sagaMiddleware.run(programmingProgramSummarySaga);
  sagaMiddleware.run(feedbackSaga);
  sagaMiddleware.run(ouSaga);
  sagaMiddleware.run(customSpacesSaga);
  sagaMiddleware.run(calculatorsSaga);
  sagaMiddleware.run(worksheetSaga);
  sagaMiddleware.run(organizationsSaga);
  sagaMiddleware.run(settingsSaga);
  sagaMiddleware.run(spaceTypesSaga);
  sagaMiddleware.run(spaceTypeCategoriesSaga);
  sagaMiddleware.run(downloadSaga);
  sagaMiddleware.run(usersSaga);
  sagaMiddleware.run(clientsSaga);
  sagaMiddleware.run(teamsSaga);
  sagaMiddleware.run(requestsSaga);
  sagaMiddleware.run(benchmarkReportsSaga);
};
